var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"ml-1",attrs:{"color":"success","fab":"","loading":_vm.refreshing,"medium":"","fixed":"","bottom":"","right":""},on:{"click":_vm.refresh}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("refresh")])],1)]}}])},[_c('span',[_vm._v("Refresh")])])}
var staticRenderFns = []

export { render, staticRenderFns }